export enum TypeOfExportProps {
  TRANSCRIPTION = "Transcription",
  MINUTES = "Minutes",
  DETAILED_MINUTES = "DetailedMinutes",
  SUMMARY = "Summary",
}
export type ExportType = typeof TypeOfExportProps;

export const exportTypeIndex = {
  Minutes: 1,
  Summary: 2,
  Transcription: 3,
  DetailedMinutes: 4,
};

export const getExportTypeText = {
  transcription: "editAndExportScreen.transcriptTitle",
  minutes: "editAndExportScreen.minutesTitle",
  summary: "editAndExportScreen.summaryTitle",
  detailedMinutes: "editAndExportScreen.detailedMinutesTitle",
};
